module.exports = __webpack_public_path__ + "static/about-f832fc3587f742945f09631fed925e5f.jpg";